import api from './api';
import type { QuoteDocumentRow, QuoteDocumentUpload } from '../types/quoteDocuments';

const quoteDocumentsService = {
  list: async (quoteNumber: number, revisionNumber: number): Promise<QuoteDocumentRow[]> => {
    const r = await api.get<QuoteDocumentRow[]>(
      `/quotes/${quoteNumber}/${revisionNumber}/documents`,
    );
    return r.data;
  },

  upload: async (
    quoteNumber: number, revisionNumber: number, file: File, meta: QuoteDocumentUpload,
  ): Promise<QuoteDocumentRow> => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('documenttype', meta.documenttype);
    if (meta.description) fd.append('description', meta.description);
    const r = await api.post<QuoteDocumentRow>(
      `/quotes/${quoteNumber}/${revisionNumber}/documents`,
      fd,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return r.data;
  },

  previewBlob: async (
    quoteNumber: number, revisionNumber: number, mapRecno: number,
  ): Promise<Blob> => {
    const r = await api.get<Blob>(
      `/quotes/${quoteNumber}/${revisionNumber}/documents/${mapRecno}/preview`,
      { responseType: 'blob' },
    );
    return r.data;
  },

  downloadBlob: async (
    quoteNumber: number, revisionNumber: number, mapRecno: number,
  ): Promise<Blob> => {
    const r = await api.get<Blob>(
      `/quotes/${quoteNumber}/${revisionNumber}/documents/${mapRecno}/download`,
      { responseType: 'blob' },
    );
    return r.data;
  },

  update: async (
    quoteNumber: number, revisionNumber: number, mapRecno: number,
    patch: { documenttype?: string; description?: string },
  ): Promise<QuoteDocumentRow> => {
    const r = await api.patch<QuoteDocumentRow>(
      `/quotes/${quoteNumber}/${revisionNumber}/documents/${mapRecno}`,
      patch,
    );
    return r.data;
  },

  remove: async (
    quoteNumber: number, revisionNumber: number, mapRecno: number,
  ): Promise<void> => {
    await api.delete(`/quotes/${quoteNumber}/${revisionNumber}/documents/${mapRecno}`);
  },

  documentTypes: async (): Promise<string[]> => {
    const r = await api.get<string[]>('/quote-document-types');
    return r.data;
  },
};

export default quoteDocumentsService;
